import { FailedToValidate } from "../failed-to-validate";

export const IncompleteExpired = FailedToValidate;
